module.exports = __webpack_public_path__ + "static_1793582269135/img/login-bg.a0b0553f.png";